module.exports = __webpack_public_path__ + "fonts/EuclidEnercity-MediumItalic-WebS.9fa8b409.woff";